import type { StreamlineIconProps } from '../../StreamlineIcon';
import type { fontAwesomeIconMap } from '../fontAwesomeIconMap';

export const streamlineIconMap: Record<keyof typeof fontAwesomeIconMap, StreamlineIconProps> = {
  'time-field-clock': { name: 'time-clock-circle' },
  'time-picker-angle-up': { name: 'arrow-up-1' },
  'time-picker-angle-down': { name: 'arrow-down-1' },
  'nested-checklist-expand-arrow': { name: 'navigate-down-thick' },
  'accordion-item-arrow': { name: 'navigate-down-thick' },
  'accordion-item-plus': { name: 'navigate-plus-thick' },
  'accordion-item-minus': { name: 'navigate-minus-thick' },
  'alert-close': { name: 'cross-thick' },
  'combo-box-delete': { name: 'remove' },
  'modal-close': { name: 'remove' },
  'select-down': { name: 'arrow-down-1' },
  'switch-off': { name: 'remove' },
  'switch-on': { name: 'check-1' },
  'collapsible-menu-submenu-arrow': { name: 'navigate-down-thick' },
  'hamburger-menu-bars': { name: 'symbol-equal' },
  'dropdown-indicator-right': { name: 'arrow-right-1' },
  'dropdown-arrow-up': { name: 'arrow-up-1' },
  'dropdown-arrow-down': { name: 'arrow-down-1' },
  'combo-box-item-selected': { name: 'check-1' },
  'date-field-calendar': { name: 'calendar' },
  'calendar-angle-left': { name: 'arrow-left-1' },
  'calendar-angle-right': { name: 'arrow-right-1' },
  'combo-box-clear': { name: 'remove' },
  'vertical-navigation-arrow-up': { name: 'arrow-up-navigation' },
  'vertical-navigation-arrow-down': { name: 'arrow-down-navigation' },
  'password-field-hide': { name: 'view-crossed' },
  'password-field-show': { name: 'view' },
  'pdf-download': { name: 'download-bottom' },
  'file-manager-delete': { name: 'remove' },
  'cmd-table-check': { name: 'check-1' },
  'cmd-table-link': { name: 'share-external-link-1' },
  print: { name: 'print-text' },
  'onboarding-imprint': { name: 'information-circle' },
  'section-toggle': { name: 'navigate-down-thick' },
  'data-grid-boolean-false': { name: 'remove' },
  'data-grid-boolean-true': { name: 'check-1' },
  'data-grid-columns': { name: 'layout-column' },
  'data-grid-context-menu': { name: 'navigation-menu-vertical' },
  'data-grid-context-menu-hide-column': { name: 'view-crossed' },
  'data-grid-density': { name: 'layout-headline' },
  'data-grid-expand': { name: 'arrow-right' },
  'data-grid-export': { name: 'download-bottom' },
  'data-grid-filter': { name: 'filter-2' },
  'data-grid-pin-left': { name: 'pin-left' },
  'data-grid-pin-right': { name: 'pin-right' },
  'data-grid-sort-asc': { name: 'direction-up' },
  'data-grid-sort-desc': { name: 'direction-down' },
  'checkbox-check': { name: 'check-thick' },
  'tree-graph-plus': { name: 'plus' },
  'tree-graph-minus': { name: 'minus' },
  'tree-graph-fit-view': { name: 'fullscreen' },
  'tree-graph-expand': { name: 'arrow-down-1' },
} as const;
